'use client';

import React from 'react';
import FooterCorporateAddress from './components/FooterCorporateAddress';
import FooterAboutSinger from './components/FooterAboutSinger';
import FooterHelpServices from './components/FooterHelpServices';
import FooterPaymentMethod from './components/FooterPaymentMethod';

function FooterPrimary() {
  return (
    <footer className="hidden lg:block bg-senate py-[52px] mt-[50px]">
      <div className="container mx-auto">
        <div className="flex justify-between flex-wrap gap-[50px]">
          {/* corporate address */}
          <FooterCorporateAddress />

          {/* about Singer */}
          <FooterAboutSinger />

          {/* help services */}
          <FooterHelpServices />

          {/* payment methods */}
          <FooterPaymentMethod />
        </div>
      </div>
    </footer>
  );
}

export default FooterPrimary;
